import {Button, TextField, Typography} from "@mui/material";
import {useState} from "react";
import Store from "../../../../context/store";
import UpdateBirthModal from "../modals/update/birth/UpdateBirthModal";
import {Desktop, Mobile, Tablet} from "../../../../Responsive";


export default function BirthModify(){

    const storeData = Store().getLoginData()

    const [modalOpen, setModalOpen] = useState(false);

    const openModal=()=>{
        setModalOpen(true);
    };
    const closeModal=()=>{
        setModalOpen(false);
    }

    return(
        <>
            <Desktop>
                <div style={{alignItems:'center',display:'flex', paddingBottom:20}}>

                    <TextField
                        defaultValue={storeData.birth}
                        key={storeData.birth}
                        required
                        fullWidth
                        type="text"
                        name="birth"
                        label="생년월일"
                        disabled
                        sx={{width:250, paddingRight:2}}
                    />

                    <Button
                        onClick={openModal}
                        variant="outlined"
                        type="submit"
                        size="medium"
                        sx={{
                            width:'90px',
                            height:'58px',
                            border:3,
                            "&.MuiButton-root:hover":{
                                color:'#008DDC',
                                backgroundColor:'#c7ebff',
                                borderColor:'#008DDC'
                            }
                        }}
                    >
                        <Typography component="h3" variant="h7">
                            수정
                        </Typography>
                    </Button>
                    {modalOpen && <UpdateBirthModal open={modalOpen} close={closeModal} header="생년월일 변경" />}

                </div>
            </Desktop>
            <Tablet>
                <div style={{alignItems:'center',display:'flex', paddingBottom:20}}>

                    <TextField
                        defaultValue={storeData.birth}
                        key={storeData.birth}
                        required
                        fullWidth
                        type="text"
                        name="birth"
                        label="생년월일"
                        disabled
                        sx={{width:250, paddingRight:2}}
                    />

                    <Button
                        onClick={openModal}
                        variant="outlined"
                        type="submit"
                        size="medium"
                        sx={{
                            width:'90px',
                            height:'58px',
                            border:3,
                            "&.MuiButton-root:hover":{
                                color:'#008DDC',
                                backgroundColor:'#c7ebff',
                                borderColor:'#008DDC'
                            }
                        }}
                    >
                        <Typography component="h3" variant="h7">
                            수정
                        </Typography>
                    </Button>
                    {modalOpen && <UpdateBirthModal open={modalOpen} close={closeModal} header="생년월일 변경" />}

                </div>
            </Tablet>
            <Mobile>
                <div style={{alignItems:'center',display:'flex', paddingBottom:20}}>

                    <TextField
                        defaultValue={storeData.birth}
                        key={storeData.birth}
                        required
                        fullWidth
                        type="text"
                        name="birth"
                        label="생년월일"
                        disabled
                        sx={{width:220, paddingRight:2}}
                    />

                    <Button
                        onClick={openModal}
                        variant="outlined"
                        type="submit"
                        size="medium"
                        sx={{
                            width:'90px',
                            height:'58px',
                            border:3,
                            "&.MuiButton-root:hover":{
                                color:'#008DDC',
                                backgroundColor:'#c7ebff',
                                borderColor:'#008DDC'
                            }
                        }}
                    >
                        <Typography component="h3" variant="h7">
                            수정
                        </Typography>
                    </Button>
                    {modalOpen && <UpdateBirthModal open={modalOpen} close={closeModal} header="생년월일 변경" sectionType="mobile" />}

                </div>
            </Mobile>


        </>
    )
}